import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhySection } from './components/WhySection';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
import { META_PIXEL_ID } from './data/content';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(script, first);else (document.head || document.documentElement).appendChild(script);
  n('init', META_PIXEL_ID);
  n('track', 'PageView');
}
interface AppProps {
  showSalesPopup?: boolean;
}
export function App({
  showSalesPopup = true
}: AppProps) {
  useEffect(() => {
    try {
      initMetaPixel();
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="35ymodf6r9ya">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="35ghusegjner" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-black font-sans text-white antialiased" data-id="element-2" data-mp="d3wcv6glvgtj">
        <main className="w-full max-w-3xl bg-carbon shadow-2xl ring-1 ring-steel/10" data-id="element-3" data-mp="3glea6jyr55fp">
          <Hero data-id="element-4" data-mp="3gj1r23h9cp12" />
          <WhySection data-id="element-5" data-mp="3bmjq7ep1tau0" />
          <SystemOverview data-id="element-6" data-mp="3bn314bga6yyj" />
          <Modules data-id="element-7" data-mp="3bnuvxk220snr" />
          <LookInside data-id="element-8" data-mp="3bk736n4foaa3" />
          <Bonuses data-id="element-9" data-mp="3qaxt1pmgszak" />
          <Differentiators data-id="element-10" data-mp="3qbfud0nzi3pc" />
          <Offer data-id="element-11" data-mp="3qcqzb3t61hi1" />
          <Guarantee data-id="element-12" data-mp="3qdajysa7ajzr" />
          <Testimonials data-id="element-13" data-mp="3lkr5zu7lpmuf" />
          <FAQ data-id="element-14" data-mp="3lk7k62etyeb4" />
          <FinalCTA data-id="element-15" data-mp="3ljpiurdb99wc" />
          <Footer data-id="element-16" data-mp="3lj67xum2vlrt" />
        </main>
        {showSalesPopup ? <SalesPopup data-id="element-17" data-mp="2xu3k250uowov" /> : null}
      </div>
    </>;
}